<template>
    <k-tool-tip :is-initial="true" size="x-small"
                   :disable-tooltip="text == undefined && !enableTooltip"
                   location="right"
                   :initials="initials" :color="color">
        <template #content>
            <slot name="content">{{text}}</slot>
        </template>
    </k-tool-tip>
</template>

<script lang="ts">
import {defineComponent, type PropType} from "vue";
import type {TColor} from "@/components/generics/types/TColor";
import KToolTip from "@/components/dds/KToolTip/KToolTip.vue";

export default defineComponent({
    components: {
        KToolTip
    },
    props: {
        text: {
            type: String,
        },
        initials: {
            type: String,
            required: true
        },
        color: {
            type: String as PropType<TColor>,
            default: "kpmgSecondary-900"
        },
        enableTooltip: {
            type: Boolean,
            default: false
        }

    }
})
</script>